import React from 'react';
import { useGetAllJobsiteWorkerDocumentTypesQuery } from 'apollo/generated/client-operations';
import { JobsiteWorkerDocumentTypes } from 'containers/workerOnboarding/types';

export function useJobsiteWorkerDocumentTypes(
  jobsiteId: string,
): JobsiteWorkerDocumentTypes {
  const { data, error, loading } = useGetAllJobsiteWorkerDocumentTypesQuery({
    variables: {
      jobsiteId,
    },
    fetchPolicy: 'no-cache',
    skip: !jobsiteId,
  });

  return React.useMemo(
    () => ({
      loading,
      error,
      jobsiteWorkerDocumentTypes: data?.getAllJobsiteWorkerDocumentTypes || [],
    }),
    [loading, error, data],
  );
}
